import React from "react";
import { Box, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";

/** Secondary file chips shown under entity body when `attachments` array is non-empty. */
export default function EntityAttachmentsList({ attachments, tc, theme, onOpenDecryptDownload }) {
  if (!attachments.length) return null;
  return (
    <Box sx={{ borderTop: `1px solid ${tc.border.subtle}`, p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 1.5 }}>
        <AttachFileIcon sx={{ fontSize: 16, color: tc.text.secondary, transform: "rotate(45deg)" }} />
        <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: tc.text.secondary }}>
          {attachments.length} attachment{attachments.length !== 1 ? "s" : ""}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        {attachments.map((file) => (
          <Box
            key={file.id}
            onClick={() => file.downloadUrl && onOpenDecryptDownload(file.downloadUrl, file.name || "download")}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              px: 1.5,
              py: 1,
              borderRadius: "8px",
              border: `1px solid ${tc.border.main}`,
              bgcolor: tc.background.infoBox,
              cursor: file.downloadUrl ? "pointer" : "default",
              maxWidth: 220,
            }}
          >
            <Typography
              sx={{
                fontSize: "0.78rem",
                fontWeight: 500,
                color: tc.text.strong,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
                minWidth: 0,
              }}
            >
              {file.name}
            </Typography>
            {file.downloadUrl && (
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  p: 0.5,
                  ml: 0.25,
                  borderRadius: "6px",
                  "&:hover": { backgroundColor: theme.palette.action.hover },
                }}
              >
                <DownloadIcon sx={{ fontSize: 14, color: tc.text.secondary }} />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
